module.exports = __webpack_public_path__ + "img/product4.3ad56c36.png";